import { Tag, Input, Space, Table, TableProps, Divider } from "antd";
import TextArea from "antd/es/input/TextArea";
import React, { useEffect, useRef, useState } from 'react';
import { InboxOutlined, UploadOutlined } from '@ant-design/icons';
import type { UploadProps } from 'antd';
import { Button, message, Upload } from 'antd';
import { CustomAxios } from "../../services/api";
import MessageListPopUp from "./message.list.modal";
import Dragger from "antd/es/upload/Dragger";

    interface TagSearchPopUpProps {
        agentSeq?: any;
        clubSeq?: any;
        selectedRecord: any;
        tagAry: string[];
        memberIdAllAry: string[];
        memberIdSearchAry: string[];
        memberIdSelectedAry: string[];
        sendType: string;
    }
    const TagSearchPopUp: React.FC<TagSearchPopUpProps> = ({ selectedRecord, tagAry ,agentSeq ,clubSeq, memberIdAllAry,memberIdSearchAry,memberIdSelectedAry,sendType}) => {
   
    console.log(">>>>>>>>>>> sendType: ", sendType); 
    
    const [sendMemberId, setSendMemberId] = useState<string[]>([]);
    useEffect(() => {
        if(sendType === "all"){
            setSendMemberId(memberIdAllAry);
        } else if(sendType === "search"){
            setSendMemberId(memberIdSearchAry);
        } else if(sendType === "selected"){
            setSendMemberId(memberIdSelectedAry);
        }
    }, [sendType, memberIdAllAry, memberIdSearchAry, memberIdSelectedAry]);

    const [checkedTags, setCheckedTags] = useState<{ [key: string]: boolean }>({}); // 체크된 태그 상태 추가
    const handleCheckboxChange = (tag: string, checked: boolean) => {
        setCheckedTags({ ...checkedTags, [tag]: checked }); // 체크된 태그 상태 업데이트
    };

    const handleOk = () => {
        console.log("Checked selectedRecord?.clubMemberSeq:", selectedRecord?.clubMemberSeq); 
        console.log("Checked checkedTags:", checkedTags); 
        console.log("Checked clubSeq:", clubSeq); 
        const trueKeys = Object.entries(checkedTags)
        .filter(([key, value]) => value === true)
        .map(([key, value]) => key);

        console.log(trueKeys); // ["진료"]
        const tagAddAllType = {
            clubSeq : Number(clubSeq),
            memberIdList:sendMemberId ,
            addMemoData: trueKeys
        };       
        console.log(" tagAddAllType:", tagAddAllType);

        CustomAxios.patchTagMemoAddAll(tagAddAllType)
        .then((response:any) => {
          console.log("postStudyCreateFile", response); 
        })
        .catch((err:any) => {
          console.log("postStudyCreateFile error", err);
        });        
    };

    const [checkedTagsD, setCheckedTagsD] = useState<{ [key: string]: boolean }>({}); // 체크된 태그 상태 추가
    const handleCheckboxChangeD = (tag: string, checked: boolean) => {
        setCheckedTagsD({ ...checkedTagsD, [tag]: checked }); // 체크된 태그 상태 업데이트
    };

    const handleOkD = () => {
        console.log("Checked selectedRecord?.clubMemberSeq:", selectedRecord?.clubMemberSeq); 
        console.log("Checked checkedTagsD:", checkedTagsD); 
        console.log("Checked clubSeq:", clubSeq); 
        const trueKeys = Object.entries(checkedTagsD)
        .filter(([key, value]) => value === true)
        .map(([key, value]) => key);

        console.log(trueKeys); // ["진료"]
        const tagDeleteAllType = {
            clubSeq : Number(clubSeq),
            memberIdList:sendMemberId ,
            deleteMemoData: trueKeys
        };       
        console.log(" tagDeleteAllType:", tagDeleteAllType);
        CustomAxios.patchTagMemoDeleteAll(tagDeleteAllType)
        .then((response:any) => {
          console.log("patchTagMemoDeleteAll", response); 
        })
        .catch((err:any) => {
          console.log("patchTagMemoDeleteAll error", err);
        });        
    };

    useEffect(() => {
        setRefresh(Date.now());
        const newCheckedTags: { [key: string]: boolean } = {};
        // tagAry.forEach(tag => {
        //     console.log("-----" , selectedRecord);
        //     newCheckedTags[tag] = selectedRecord.memoData.includes(tag);
        // });
        // setCheckedTags(newCheckedTags);
    }, [tagAry]);



    const timestamp = Date.now();
    const [refresh, setRefresh] = useState(timestamp);

    return (
        <div style={{ height: '300px', overflowY: 'auto' }}>
        <div style={{ marginTop : 0, marginBottom : 30 }}><Space>태그 변경할 대상 : {sendMemberId.length}명이 선택되었습니다.</Space> <br/><Space>태그선택후 태그추가나 태그삭제를 누르면 일괄반영됩니다.</Space></div>     

        <Divider orientation="left" plain orientationMargin="0">태그추가</Divider>
         <p>
         {tagAry.map((tag, index) => (
                    <>
                    <input 
                    key={`tag_${index}`} 
                    type="checkbox" 
                    id={`tag_${index}`} 
                    name={`tag_${index}`} 
                    value={tag} 
                    checked={checkedTags[tag] || false} // 체크된 태그인지 확인하여 checked 속성 설정
                    onChange={(e) => handleCheckboxChange(tag, e.target.checked)} // 체크 상태 변경 핸들러
                    />
                    <label htmlFor={`tag_${index}`}>{tag}</label>
                    </>
                 ))}
                  <Button type="primary" style={{  width: 100, marginLeft : 10 }} icon={<UploadOutlined />} onClick={handleOk}>태그추가</Button>
         </p>
        
         <Divider orientation="left" plain orientationMargin="0">태그삭제</Divider>
         <p>
         {tagAry.map((tag, index) => (
                    <>
                    <input 
                    key={`tagd_${index}`} 
                    type="checkbox" 
                    id={`tagd_${index}`} 
                    name={`tagd_${index}`} 
                    value={tag} 
                    checked={checkedTagsD[tag] || false} // 체크된 태그인지 확인하여 checked 속성 설정
                    onChange={(e) => handleCheckboxChangeD(tag, e.target.checked)} // 체크 상태 변경 핸들러
                    />
                    <label htmlFor={`tagd_${index}`}>{tag}</label>
                    </>
                 ))}
                  <Button danger type="primary" style={{  width: 100, marginLeft : 10 }} icon={<UploadOutlined />} onClick={handleOkD}>태그삭제</Button>
         </p>
         
        </div>        
    );
}
export default TagSearchPopUp;

